define(["require", "exports", "tslib", "@material-ui/core/Fade", "@material-ui/core/Link", "@material-ui/core/Tooltip", "@material-ui/core/styles", "@material-ui/icons/Help", "react", "../../utils/MathUtil"], function (require, exports, tslib_1, Fade_1, Link_1, Tooltip_1, styles_1, Help_1, React, MathUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Tooltip = exports.TooltipLink = void 0;
    Fade_1 = tslib_1.__importDefault(Fade_1);
    Link_1 = tslib_1.__importDefault(Link_1);
    Tooltip_1 = tslib_1.__importDefault(Tooltip_1);
    Help_1 = tslib_1.__importDefault(Help_1);
    React = tslib_1.__importStar(React);
    const useStyles = (0, styles_1.makeStyles)(theme => ({
        root: {
            display: 'flex',
            flexDirection: "column",
            alignItems: "flex-start",
            paddingLeft: 4,
            justifyContent: 'center'
        }
    }));
    const StyledToolip = (0, styles_1.withStyles)((theme) => ({
        tooltip: {
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "400px",
            fontSize: "inherit",
            background: 'rgba(0, 0, 0, 0.8)',
            color: "white"
        },
    }))(Tooltip_1.default);
    function VariableWidth(props) {
        let { id, children, text, delayShow, delayHide, place, style } = props;
        const classes = useStyles();
        id = id || `tt-${(0, MathUtil_1.random)()}`;
        children = children || React.createElement(Help_1.default, { style: { color: "#999999", width: "22px", height: "22px" } });
        style = style || {};
        return React.createElement("div", { className: classes.root, style: style },
            React.createElement(StyledToolip, { id: id, title: text, enterDelay: delayShow || 0, leaveDelay: delayHide || 0, placement: place || "bottom", TransitionComponent: Fade_1.default, interactive: true }, children));
    }
    const TooltipLink = (props) => {
        return React.createElement(Link_1.default, Object.assign({}, props, { className: "tt-text" }));
    };
    exports.TooltipLink = TooltipLink;
    exports.Tooltip = VariableWidth;
    exports.default = VariableWidth;
});
